import { useCallback, useEffect, useState } from "react";
import { useFetch } from "@common/hook/useFetch";
import { getSweeprOtcUserRoute } from "@api-routes/sweepr";
import type { ISweeprOtcPayload } from "@pages/Home/type/ISweeprOtcPayload";
import { mapSweeprOtcResponse } from "@pages/Home/HomeMenuModal/sweepr/mapSweeprOtcResponse";

interface IParams {
    isEnabled: boolean;
}

export const useSweeprOtc = ({ isEnabled }: IParams) => {
    const [fetchState, { get }] = useFetch();
    const [otcPayload, setOtcPayload] = useState<ISweeprOtcPayload | null>(null);

    const fetchOtc = useCallback(
        () =>
            get<unknown>(getSweeprOtcUserRoute(), { forwardError: true }).then((response) => {
                const mappedPayload = mapSweeprOtcResponse(response);

                setOtcPayload(mappedPayload ?? null);

                return mappedPayload;
            }),
        [get]
    );

    useEffect(() => {
        if (isEnabled) {
            fetchOtc();
        } else {
            setOtcPayload(null);
        }
    }, [fetchOtc, isEnabled]);

    return {
        error: fetchState.error,
        isLoading: fetchState.isLoading,
        otcPayload,
        retryFetch: fetchOtc,
    };
};
